import Login from './pages/login';
import Home from './pages/home';
import Onboarding from './pages/onboarding';
import Invitation from './pages/invitation';
import Terminals from './pages/terminals';
import Employees from './pages/employees';
import Locations from './pages/locations';
import Transactions from './pages/transactions';
import PaymentDetailsPage from './pages/paymentDetails';
import Payrolls from './pages/payrolls';
import AccountsPage from './pages/accounts';
import ProfilePage from './pages/profile';
import BeneficiariesPage from './pages/beneficiaries';
import KycPage from './pages/kyc';
import PasswordResetRequest from './pages/passwordResetRequest';
import PasswordReset from './pages/passwordReset';
import PasswordResetTokenExpired from './pages/passwordResetTokenExpired';
import PasswordResetOtherError from './pages/passwordResetOtherError';
import PasswordResetSuccess from './pages/passwordResetSuccess';
import PasswordResetEmailSent from './pages/passwordResetEmailSent';
import NoBusinessProfile from './pages/noBusinessProfile';
import NotAuthorized from './pages/notAuthorized';
import SendMoney from './pages/sendMoney';

export const login = 'login';
export const invitation = 'invitation';
export const onboarding = 'onboarding';
export const terminals = 'terminals';
export const employees = 'employees';
export const locations = 'locations';
export const transactions = 'transactions';
export const paymentDetails = 'paymentDetails';
export const payrolls = 'payrolls';
export const accounts = 'accounts';
export const profile = 'profile';
export const beneficiaries = 'beneficiaries';
export const identity = 'identity';
export const kyc = 'kyc';
export const passwordResetRequest = 'passwordResetRequest';
export const passwordReset = 'passwordReset';
export const passwordResetTokenExpired = 'passwordResetTokenExpired';
export const passwordResetOtherError = 'passwordResetOtherError';
export const passwordResetSuccess = 'passwordResetSuccess';
export const passwordResetEmailSent = 'passwordResetEmailSent';
export const noBusinessProfile = 'noBusinessProfile';
export const notAuthorized = 'notAuthorized';
export const sendMoney = 'sendMoney';

export const specialRoutes = [
  {
    path: `/${login}`,
    exact: true,
    component: Login,
  },
  {
    path: `/${onboarding}`,
    exact: false,
    component: Onboarding,
  },
  {
    path: `/${invitation}`,
    exact: false,
    component: Invitation,
  },
  {
    path: `/${passwordResetRequest}`,
    exact: false,
    component: PasswordResetRequest,
  },
  {
    path: `/${passwordReset}`,
    exact: false,
    component: PasswordReset,
  },
  {
    path: `/${passwordResetTokenExpired}`,
    exact: false,
    component: PasswordResetTokenExpired,
  },
  {
    path: `/${passwordResetOtherError}`,
    exact: false,
    component: PasswordResetOtherError,
  },
  {
    path: `/${passwordResetSuccess}`,
    exact: false,
    component: PasswordResetSuccess,
  },
  {
    path: `/${passwordResetEmailSent}`,
    exact: false,
    component: PasswordResetEmailSent,
  },
  {
    path: `/${noBusinessProfile}`,
    exact: false,
    component: NoBusinessProfile,
  },
  {
    path: `/${notAuthorized}`,
    exact: false,
    component: NotAuthorized,
  },
];

export const defaultRoutes = [
  {
    path: '/',
    exact: true,
    component: Home,
  },
  {
    path: `/${terminals}`,
    exact: true,
    component: Terminals,
  },
  {
    path: `/${beneficiaries}`,
    exact: true,
    component: BeneficiariesPage,
  },
  {
    path: `/${employees}`,
    exact: true,
    component: Employees,
  },
  {
    path: `/${locations}`,
    exact: true,
    component: Locations,
  },
  {
    path: `/${transactions}`,
    exact: true,
    component: Transactions,
  },
  {
    path: `/${paymentDetails}`,
    exact: true,
    component: PaymentDetailsPage,
  },
  {
    path: `/${payrolls}`,
    exact: true,
    component: Payrolls,
  },
  {
    path: `/${accounts}`,
    exact: true,
    component: AccountsPage,
  },
  {
    path: `/${accounts}/balances`,
    exact: true,
    component: AccountsPage,
  },
  {
    path: `/${profile}`,
    exact: true,
    component: ProfilePage,
  },
  {
    path: `/${kyc}`,
    exact: true,
    component: KycPage,
  },
  {
    path: `/${sendMoney}`,
    exact: true,
    component: SendMoney,
  },
];
